<template>
  <div id="assist__choose" class="animated fadeIn" @click.self="close">
    <div id="container" class="container animated slideInUp">
      <div class="top">
        <h1>选择课时奖励</h1>
        <p>根据孩子年龄，选择好友助力给您的课程</p>
      </div>
      <div class="course">
        <div
          v-for="item in rules"
          :key="item.id"
          class="course__item"
          @click="selected = item"
          :class="{ selected: item.id == selected.id }"
        >
          <div class="left">
            <div class="img" :style="$bgd(item.img)" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="subtitle">{{ item.subtitle }}</div>
            <div class="reward" v-if="item.amount && item.lesson_length">
              <i class="anyteachicon anyteach-homeclass"></i>
              <span v-if="item.lesson_length == 1440">{{ item.amount }} 天</span>
              <span v-else>
                <span v-if="item.amount > 1">{{ item.amount }} ×</span>
                <span>{{ item.lesson_length }} 分钟</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div @click="confirm" class="button" :class="{ disabled: !selected.id }">
        确认奖励，生成海报
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssistChoose",
  props: ["rules"],
  data() {
    return {
      selected: {
        id: null,
      },
    }
  },
  methods: {
    close() {
      const el = document.getElementById("container")
      el.classList.add("slideOutDown")
      const main = document.getElementById("assist__choose")
      main.classList.add("fadeOut")
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    confirm() {
      if (!this.selected.id) {
        return this.$toast("请选择课时奖励")
      }
      this.$emit("choose", this.selected)
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
#assist__choose {
  background: $blackBgd;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: flex-end;
}

.animated {
  animation-delay: 0s !important;
  animation-duration: 0.5s !important;
}
.container {
  padding: 15px 20px 30px 20px;
  background: white;
  width: 100%;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  .top {
    padding: 5px 0 15px 0;
    text-align: center;
    h1 {
      font-size: 1rem;
      @include avenir-demi();
      margin: 0 0 3px 0;
    }
    p {
      font-size: 0.9rem;
      opacity: 0.6;
    }
  }
}

.selected {
  border-color: $purple;
}

.button {
  background: $purple;
  @include avenir-demi();
  font-size: 0.9rem;
  text-align: center;
  padding: 10px 0;
  width: 100%;
  border-radius: 4px;
  color: white;
  transition: all 0.1s;
  &:active {
    opacity: 0.6;
  }
}
.disabled {
  @include secondary();
}
</style>
